<template>
	<div class="login-body">
		<div class="login-wrapper">
			<div class="login-panel">
        <div>
        </div>

				<div class="login-form">
          <!-- SIGNIN -->
          <img src="assets/irinox/logo/logo-new.png" width="200" alt="Irinox FreshCloud" style="margin-bottom: 50px"/>
          <div class="title">{{$t('changePassword.title')}}</div>
          <label for="changePassword.password">
              {{$t('changePassword.password')}}
              <i class="pi pi-info-circle" v-tooltip="$t('changePassword.password_tooltip')"/>
          </label>
          <Password id="changePassword.password" :placeholder="$t('changePassword.password_ph')" v-model="changePassword.password" 
            :feedback="false" :class="{'p-invalid':v$.changePassword.password.$invalid && changePassword.submitted}" toggleMask  />
          <div v-if="v$.changePassword.password.$invalid && changePassword.submitted" class="form-field-error">{{$t('changePassword.password_tooltip')}}</div>
          <label for="changePassword.confirmPassword">{{$t('changePassword.confirmPassword')}}</label>
          <Password id="changePassword.confirmPassword" :placeholder="$t('changePassword.confirmPassword_ph')" v-model="changePassword.confirmPassword" 
            :feedback="false" :class="{'p-invalid':v$.changePassword.confirmPassword.$invalid && changePassword.submitted}" toggleMask  />

          <Button v-if="!changePassword.success" :label="$t('changePassword.button')" type="button" @click="changePwd(!v$.changePassword.$invalid)" style="margin-top: 20px"></Button>
          <small v-if="!changePassword.success && changePassword.error" class="p-mt-3" style="color: #f44336;">{{$t('signup.error')}}</small>

          <small v-if="changePassword.success" style="color: #068133;" class="p-mt-3" >{{$t('changePassword.success')}}</small>
          <Button v-if="changePassword.success" :label="$t('changePassword.loginButton')" type="button" @click="$router.push({ name: 'login' });" style="margin-top: 20px"></Button>

        </div>

        <p><LocaleChanger class="p-mb-3" /></p>
			</div>
			<div class="login-image">
        <div></div>
				<div class="login-image-content">
				</div>
				<div class="image-footer"></div>
			</div>
		</div>
	</div>
  <Loader></Loader>
</template>

<script>
import LocaleChanger from '../components/LocaleChanger';
import Loader from '../components/Loader.vue';
import AccountService from '../service/AccountService';
import { required, sameAs, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
          token: this.$route.query.token,
          email: this.$route.query.email,
          changePassword: {
            password: null,
            confirmPassword: null,
            error: null,
            success: false,
            submitted: false,
          },
        };
    },
    validations() {
        return {
            changePassword: {
              password: {
                  required,
                  minLength: minLength(10),
                  valid: this.$functions.passwordCheck,
              },
              confirmPassword: {
                required,
                sameAs: sameAs(this.changePassword.password),
              },
            },
        }
    },
    created() {
        this.accountService = new AccountService();
    },
    mounted() {
      console.debug("TOKEN "+this.token);
      console.debug("EMAIL "+this.email);
      if(!this.token || !this.email) {
        this.$router.push({ name: 'login' });
      }
    },
    methods: {
        changePwd: async function(isFormValid) {
          this.changePassword.submitted = true;

          if (!isFormValid) {
            return;
          }

          this.changePassword.error = null;

          this.accountService.changePassword(this.email, this.token, this.changePassword.password)
            .then(data => {
              console.log(JSON.stringify(data));
              if(data.code=="200") {
                this.changePassword.success = true;
              } else {
                console.error("EXCEPTION "+JSON.stringify(data));
                this.changePassword.error = JSON.stringify(data);
              }
            })
            .catch(error => {
              console.error(JSON.stringify(error));
              this.changePassword.error = JSON.stringify(error);
            });
        }
    },
    components: {
        LocaleChanger,
        Loader
    },
};
</script>

<style lang="scss">

.login-body .login-wrapper .login-panel .login-form .p-dropdown {
   width: 85%;
    margin-bottom: 20px;
    box-shadow: 0px 4px 10px 0px #0000001a;
    font-size: 17px;
}
.login-body .login-wrapper .login-panel .login-form .p-dropdown .p-dropdown-label {
  font-size: 17px;
  text-align: left;
}
.login-body .login-wrapper .login-panel .login-form .p-dropdown-label.p-placeholder {
  font-size: 17px;
  text-align: left;
  color: #262626;
}
.login-body .login-wrapper .login-panel .p-field-checkbox p > a {
  text-decoration: underline;
}
.pi.pi-info-circle {
  font-size: 15px;
  cursor: pointer;
}
.p-tooltip {
  font-size: 15px  !important;
}

</style>
<style lang="scss" scoped>

.login-body .login-wrapper .login-panel .login-form {
  width: 100%;
}
.login-body .login-wrapper .login-panel .login-form > input {
  max-width: none;
}
.login-body .login-wrapper .login-panel .login-form > div {
  width: 85%;
}
.login-body .login-wrapper .login-panel .login-form .p-password-input {
  width: 100% !important;
  max-width: none !important;
}

.login-body .login-wrapper .login-panel .login-form .title {
  text-align: left;
  font-size: 30px;
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 10px;
}
.login-body .login-wrapper .login-panel .login-form label {
  font-size: 17px;
  font-weight: 300;
}
.login-body .login-wrapper .login-panel .login-form label {
  width: 85%;
  font-size: 17px;
  text-align: left;
  font-weight: 600;
}
.login-body .login-wrapper .login-panel .login-form .forgot-password {
  font-size: 17px;
  font-weight: 300;
  float: right;
}
.login-body .login-wrapper .login-panel .login-form .register {
  font-size: 17px;
  font-weight: 300;
  margin-top: 20px;
}
.login-body .login-wrapper .login-panel .login-form .p-col {
  padding: 0;
}

.login-body .logo-top-left {
  width: 42px; 
  height: 34px;
}

a {
  text-decoration: underline;
  cursor: pointer;
}

.login-body .login-wrapper .login-panel .p-field-checkbox p {
  font-size: 17px;
  font-weight: 300;
  color: #002445;
  margin-left: 10px;
  text-align: left;
}

.p-field-checkbox {
  margin-bottom: 5px;
}

.login-body .login-wrapper .login-panel .login-form .form-field-error {
  color: #A70008;
  margin-top: -15px;
  font-size: 15px;
  line-height: 17px;
  margin-bottom: 15px;
  text-align: left;
}

</style>

